import HeroSection, { HeroSectionProps } from "@components/E-Book/Herosection";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";
import React from "react";

const HeroSectionData: HeroSectionProps = {
    title: "Why (just) WhatsApp is Insufficient to Grow your Business",
    listHeading:
        "WhatsApp or WhatsApp Business as a standalone doesn't cut it if you're looking to grow your business. Find out how WhatsApp Business API can transform your rules of engagement with prospects and customers using automation.",
    listText: [
        { label: "Why and when you should move from WhatsApp Business to WhatsApp Business API" },
        { label: "Detailed process of automating sales, marketing and support functions" },
        { label: "Real-life stories of fast-growing companies who have grown multifold with WA automation" },
    ],

    buttonText: "Download your free Ebook now!",
    mediaUrl: "https://assets.gallabox.com/gb-home/ebook/whatsapp-for-marketing.png",
    altMedia: "gallabox-e-book",
    ebookName: "business-ebook",
};

const EBookWhyWhatsappForBusiness: React.FC = () => {
    return (
        <NewLayout
            title="Why businesses need WhatsApp API to scale | Free ebook"
            description="WhatsApp Business as a standalone is not enough for a growing business. This ebook helps you understand how WhatsApp Business API can transform your engagement with prospects and customers as you scale."
            canonical="https://gallabox.com//resources/why-whatsapp-business-api-ebook"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ebook/wa-for-business-ebook-og.png" }}
            keywords="whatsapp business api, whatsapp api for business, how does whatsapp business api work, whatsapp business api pricing, how much does whatsapp business api cost"
        >
            <HeroSection {...HeroSectionData} />
            <section className="flex flex-col pb-10 pr-12">
                <div className="px-8 max-w-6xl mx-auto client-logos flex flex-col gap-3">
                    <Image width={221} height={56} src="/frame.png" alt={"Frame"} className="flex-shrink" />
                    <div className="lg:flex justify-between items-center">
                        <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-14">
                            Trusted by over <span className="font-bold">10,000 companies</span> across <span className="font-bold">40+ </span> countries
                        </h3>
                        <div className="flex justify-center mb-9">
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:block hidden"
                            />
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:hidden"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default EBookWhyWhatsappForBusiness;
